import { Map, OrderedMap, fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';

// Constants
import WorkspaceAiSettingsConstants from 'Shared/constants/WorkspaceAiSettings.constants';
import AiSuggestionWorkspaceItemsConstants from 'Shared/constants/AiSuggestionWorkspaceItems.constants';

const initialState = Map({
  [WorkspaceAiSettingsConstants.State.WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG]: OrderedMap(),
});

export const WorkspaceAiSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'WORKSPACE_GET_RESPONSE':
      return state.updateIn(
        [WorkspaceAiSettingsConstants.State.WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG],
        (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              action.data.workspaceAiSettings.data.map(item => [
                action.data.id,
                OrderedMap([[item.attributes.slug, Map(fromJS(item.attributes))]]),
              ])
            )
          )
      );
    case WorkspaceAiSettingsConstants.Actions.CREATE_WORKSPACE_AI_SETTING_SUCCESS:
    case WorkspaceAiSettingsConstants.Actions.UPDATE_WORKSPACE_AI_SETTING_SUCCESS:
      // is there is no data, json-api-normalizr will convert payload to
      // an empty object, we need to ensure it's not empty before trying to iterate over items
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn(
        [WorkspaceAiSettingsConstants.State.WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG],
        (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.workspaceAiSetting).map(item => [
                action.payload.workspaceId,
                OrderedMap([[item.attributes.slug, Map(fromJS(item.attributes))]]),
              ])
            )
          )
      );

    case AiSuggestionWorkspaceItemsConstants.Actions.CREATE_NEW_AI_SUGGESTIONS_WORKSPACE_ITEMS_SUCCESS:
      return state.updateIn(
        [WorkspaceAiSettingsConstants.State.WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG, action.payload.workspaceId],
        (existing = OrderedMap()) => existing.map(item => item.set('anyAiChatScanRequests', true))
      );

    default:
      return state;
  }
};
